module.exports = __webpack_public_path__ + "media/SalesBell.30a941f9.wav";